import orgManage from './orgManage.js'
import courseIssuance from './courseIssuance.js'
import testpaperManage from './testpaperMange.js'
import rolePermissions from './rolePermissions.js'
import studyProgress from './studyProgress.js'
import studentManage from './studentManage.js'
import examManage from './examManage.js'
import courseManage from './courseManage.js'
import settingManage from './settingManage.js'
import grouping from "./grouping.js";
import classlist from "./classlist.js";
import testPaperManage from "./testPaperManage.js";
import certificateManage from "./certificate";
import completionCertificates from './completionCertificates';
import merchandiseManage from "@/menu/merchandiseManage";
import researchManage from "@/menu/researchManage";



// 哈哈
/**
 * 首页
 * @type {{name: string, path: string, icon: string}}
 */
let home = {
  name: '首页',
  path: '/',
  permissionsKey: "",
  icon: 'fa fa-tachometer',
};

let helpCenter = {
  name: '帮助中心',
  path: '/help_center',
  permissionsKey: "",
  icon: 'fa fa-question-circle',

};
export default {
  home,
  orgManage,
  merchandiseManage,
  studyProgress,
  courseIssuance,
  testpaperManage,
  certificateManage,
  researchManage,
  rolePermissions,
  grouping,
  studentManage,
  classlist,
  examManage,
  testPaperManage,
  courseManage,
  completionCertificates,
  settingManage,
  //helpCenter
};

